import ILoadsImportResultCardProps from './interfaces/ILoadsImportResultCardProps';
import './loads-import-result-card.scss';

function LoadsImportResultCard({
    item,
    description,
    itemValue,
    itemValueColor,
}: Readonly<ILoadsImportResultCardProps>) {
    return (
        <div>
            <div
                className="loads-result-card__container"
                data-testid="loads-result-card__container"
            >
                <div
                    className="loads-result-card__container-item"
                    data-testid="loads-result-card__container-item"
                >
                    {item}
                </div>
                <div
                    className="loads-result-card__container-description"
                    data-testid="loads-result-card__container-description"
                >
                    <h1>{description}</h1>
                </div>
                <div
                    className="loads-result-card__container-itemValue"
                    style={{ color: itemValueColor }}
                    data-testid="loads-result-card__container-itemValue"
                >
                    <h1>{itemValue}</h1>
                </div>
            </div>
        </div>
    );
}

export default LoadsImportResultCard;
